export const GET_SHAPES = 'Get_Shapes';